import * as React from 'react';
import {Wrapper} from '../../styled';
import InputContainer from 'containers/InputContainer';
import Input from 'components/Input';
import TextEditor from 'components/TextEditor';

/**
 * The component of free answer content block.
 * @return {React.ReactElement}
 * @constructor
 */
export default function FreeAnswer(): React.ReactElement {
  return (
    <Wrapper>
      <InputContainer label="Описание">
        <div>
          <TextEditor />
        </div>
      </InputContainer>
      <br/>
      <Input value="Поле для ответа. Заполняется учеником" disabled />
    </Wrapper>
  );
}
